import { render, staticRenderFns } from "./system_management_home.vue?vue&type=template&id=6540dd20&scoped=true"
import script from "./system_management_home.vue?vue&type=script&lang=js"
export * from "./system_management_home.vue?vue&type=script&lang=js"
import style0 from "./system_management_home.vue?vue&type=style&index=0&id=6540dd20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6540dd20",
  null
  
)

export default component.exports